// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"876b52e7","129":"0e0bee5e","555":"d7338944","645":"123598c5"}[chunkId] + ".chunk.js";
};